export * from './popconfirm.component.js';
export * from './popconfirm.types.js';
